import { defineStore } from 'pinia';
import axios from 'axios';

export const useRegistrationFormSettingsStore = defineStore('registrationFormSettings', {
    state: () => ({
        loading: false,
        academicYear: null,
        formSettings: null,
    }),

    actions: {
        async fetchSettings(academicYearId) {
            this.loading = true;
            try {
                const { data } = await axios.get(`/academic-years/${academicYearId}/registration-settings`);
                this.academicYear = data.academic_year;
                this.formSettings = data.form_settings;
                return data.form_settings;
            } finally {
                this.loading = false;
            }
        },

        async updateSettings(academicYearId, formSettings) {
            const { data } = await axios.put(`/academic-years/${academicYearId}/registration-settings`, formSettings);
            this.academicYear = data.academic_year;
            this.formSettings = data.form_settings;
            return data.form_settings;
        },
    },
});
